import React from 'react'
import { makeStyles } from '@material-ui/styles'
import {
    Box,
    Checkbox,
    Typography
} from '@material-ui/core'
import { TreeView, TreeItem } from '@material-ui/lab'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import ChevronRightIcon from '@material-ui/icons/ChevronRight'
import RemoveIcon from '@material-ui/icons/Remove'
import { useTranslation } from 'react-i18next'

const useStyles = makeStyles(theme => ({
    treeItem: {
        marginBottom: 10,
    },
    label: {
        display: 'inline-block',
        overflowWrap: 'break-word',
    },
}))


function TreeFilter({ treeOptions, values, setValues }) {
    const classes = useStyles()
    const { t } = useTranslation()

    const [expanded, setExpanded] = React.useState([])
    const handleToggle = (event, nodeIds) => {
        setExpanded(nodeIds)
    }

    const recursivelyGetValues = optionObj => {
        if (optionObj.children) {
            return [].concat(...optionObj.children.map(recursivelyGetValues))
        } else {
            return [optionObj.value]
        }
    }

    const toggleCheckbox = (childValues) => {
        const wasActive = childValues.every(v => values.includes(v))
        let newValues
        if (wasActive) {
            newValues = values.filter(v => !childValues.includes(v))
        } else {
            newValues = [...new Set([...values, ...childValues])]
        }
        setValues(newValues)
    }

    const recursiveTreeRender = optionObj => {
        const childValues = recursivelyGetValues(optionObj)

        return <TreeItem
            className={classes.treeItem}
            key={optionObj.value}
            nodeId={optionObj.value}
            label={<Box
                display='flex' justifyContent='space-between' alignItems='center' wrap='nowrap'
                onClick={() => {
                    if (!optionObj.children) {
                        toggleCheckbox(childValues)
                    }

                }}
            >
                <Typography className={classes.label}>
                    {t(`filters.valueMappings.${optionObj.value}`)}
                </Typography>
                <Checkbox
                    checked={childValues.every(v => values.includes(v))}
                    indeterminate={
                        childValues.some(v => values.includes(v)) &&
                        !childValues.every(v => values.includes(v))
                    }
                    color='primary'
                    onClick={(e) => {
                        e.stopPropagation()
                        toggleCheckbox(childValues)
                    }}
                />
            </Box>}
        >
            {optionObj.children && optionObj.children.map(recursiveTreeRender)}
        </TreeItem>
    }

    return (
        <TreeView
            key='static'
            expanded={expanded}
            onNodeToggle={handleToggle}
            defaultCollapseIcon={<ExpandMoreIcon />}
            defaultExpandIcon={<ChevronRightIcon />}
            defaultEndIcon={<RemoveIcon />}
        >
            {treeOptions.map(recursiveTreeRender)}
        </TreeView>
    )
}


export default TreeFilter
